import React from 'react';
import { useTranslation } from 'localization';
import { ChannelScope } from 'types/channel';
import TagAtom from '../../atoms/Tag/TagAtom';
import { MARKETPLACE_SCOPE_ICONS } from '../../atoms/marketplace/iconMaps';
import './ScopeFilterMolecule.scss';

export type ScopeFilterValue = 'all' | ChannelScope;

export interface ScopeFilterMoleculeProps {
  value: ScopeFilterValue;
  onChange: (scope: ScopeFilterValue) => void;
  className?: string;
}

const SCOPES: ScopeFilterValue[] = [
  'all',
  'center',
  'organization',
  'metasphere',
];

const SCOPE_LABEL_KEY: Record<ScopeFilterValue, string> = {
  all: 'marketplace.scopeFilter.all',
  center: 'marketplace.scopeFilter.myCenters',
  organization: 'marketplace.scopeFilter.myOrg',
  metasphere: 'marketplace.scopeFilter.metasphere',
};

export const ScopeFilterMolecule: React.FC<ScopeFilterMoleculeProps> = ({
  value,
  onChange,
  className = '',
}) => {
  const { t } = useTranslation();
  const classes = ['marketplace-scope-filter', className].filter(Boolean).join(' ');

  return (
    <div className={classes} role="group">
      {SCOPES.map((scope) => (
        <TagAtom
          key={scope}
          tone="neutral"
          icon={MARKETPLACE_SCOPE_ICONS[scope]}
          label={t(SCOPE_LABEL_KEY[scope])}
          pressed={value === scope}
          onClick={() => onChange(scope)}
          size="large"
        />
      ))}
    </div>
  );
};

export default ScopeFilterMolecule;
